export default "__VITE_PUBLIC_ASSET__03637c82__"